export default [{
  path: '/v1/rechangelimit',
  name: 'rechangelimit',
  component: resolve => require(['@/pages/recharge-limit/index'], resolve),
  meta: {
    title: '限额充值',
    isLoding: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/rechargeLimitV1.js